var exports = {
  "success": "PurchaseHistoryStatus.module__success___NWpsQU",
  "pending": "PurchaseHistoryStatus.module__pending___NWpsQU",
  "muted": "PurchaseHistoryStatus.module__muted___NWpsQU",
  "neutral": "PurchaseHistoryStatus.module__neutral___NWpsQU",
  "danger": "PurchaseHistoryStatus.module__danger___NWpsQU",
};

__webpack_require__.r(module.exports = exports);
